import { useContext } from "react";
import AssessmentsBeta from "./beta/Assesments";
import AssessmentsCurrent from "./current/Assesments";
import { GlobalContext } from "../../context/GlobalState";

export default function Assessments() {
  const { cbqBetaAccess } = useContext(GlobalContext);
  return cbqBetaAccess ? <AssessmentsBeta /> : <AssessmentsCurrent />;
}
